const TYPE_CLASS = {
    info: 'label-info',
    primary: 'label-primary',
    secondary: 'label-secondary',
    success: 'label-success',
    warning: 'label-warning',
    danger: 'label-danger',
    inactive: 'disabled',
    'inactive-skynet': 'disabled',
};

export function InfoLabel({ type, title, onClick }) {
    const typeClass = TYPE_CLASS[(type ?? '').trim()] ?? '';
    const className = ['label', typeClass, onClick && 'cursorpointer'].filter(Boolean).join(' ');

    return <label className={className} onClick={onClick}>{title}</label>;
}
